import logo from './logo.svg';
import './App.css';
import FormSpesa from './components/FormSpesa';

function App() {
  return (
    <>
      <FormSpesa /> 
    </>
  );
}

export default App;
